import { showInputModal } from '@components/InputModal';
import { $categoryListApi, $categoryMapApi } from '@stores/dataStores';
import { getNewCategoryId } from '../utils/getNewCategoryId';

const addCategory = () => {
  showInputModal({
    title: '新建一级分组',
    maxLength: 50,
    placeholder: '请输入分组名称',
  }).then(({ value }) => {
    if (value === undefined) return;
    const id = getNewCategoryId();
    $categoryMapApi.update((draft) => {
      draft.set(id, { id, name: value, categoryIds: [], sceneIds: [] });
    });
    $categoryListApi.update((draft) => {
      draft.push(id);
    });
  });
};

export default addCategory;
